import { Component, OnInit } from '@angular/core';
import { DataService } from '../../common/data.service';
import { CarouselModule } from 'primeng/carousel';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    
    constructor(private gservice: DataService, private router: Router) { }
    ngOnInit() {
       
    }
   
}
